import { useLayoutEffect, useEffect } from 'react'; // suppress the useLayoutEffect warning on server side.

export var useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;


//////////////////
// WEBPACK FOOTER
// ./~/react-dnd/dist/esm/hooks/internal/useIsomorphicLayoutEffect.js
// module id = 84
// module chunks = 4